// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';
import QuestionIconSource from './quetion.svg';
import { translate } from '@tectonics/translate';

export function ImportantToKnow(): Node {
  return (
    <ImportantToKnowWrapper>
      <Title>{translate('volcanes.opened-payment.fawry.importantMessage.title')}</Title>
      <Row>
        <QuestionIcon src={QuestionIconSource} />
        <Text>
          {translate('volcanes.opened-payment.fawry.importantMessage.description')}
        </Text>
      </Row>
    </ImportantToKnowWrapper>
  );
}

const ImportantToKnowWrapper = styled.div`
  margin: 32px 0;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  border: 1px solid rgb(220, 225, 230);
  border-radius: 5px;
  padding: 14px;
  gap: 14px;
`;

const Title = styled.div`
  font-size: 1em;
  font-weight: 700;
  font-family: ${props => props.theme.fontFamily.display};
`;

const Text = styled.div`
  font-size: 0.9em;
  font-family: ${props => props.theme.fontFamily.display};
  text-align: justify;
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 14px;
`;

const QuestionIcon = styled.img`
  width: 48px;
  height: 48px;
`;
